import { cloneExecutableScript } from './injectHTML';
export default class ScriptExecutionQueue {
  constructor(scriptsToExecute) {
    this.scriptsToExecute = scriptsToExecute;
    this.previousScriptEl = undefined;
    this.scriptLoadedMap = new Map();
    this.error = undefined;
  }
  start() {
    if (this.scriptsToExecute.length > 0) {
      this.replaceScriptUntilInlineScript();
    }
  }
  replacePreviousScript(scriptEl) {
    try {
      const newScript = cloneExecutableScript(scriptEl);

      // Keep track of script that have been already loaded
      if (newScript.src) {
        newScript.addEventListener('load', () => {
          this.scriptLoadedMap.set(newScript.src, true);
          this.replaceScriptUntilInlineScript();
        });
        newScript.addEventListener('error', () => {
          this.scriptLoadedMap.set(newScript.src, true);
          this.replaceScriptUntilInlineScript();
        });
      }
      scriptEl.replaceWith(newScript);
    } catch (e) {
      this.error = e;
    }
  }
  replaceScriptUntilInlineScript() {
    let scriptEl;
    while (this.scriptsToExecute.length > 0 && !this.error) {
      scriptEl = this.scriptsToExecute[0];
      if (scriptEl && scriptEl.parentElement) {
        const isExternalScript = !!scriptEl.src;
        const noPreviousScript = !this.previousScriptEl;
        const previousScriptWasLoadedOrWasInline = this.previousScriptEl && (!this.previousScriptEl.src || this.scriptLoadedMap.get(this.previousScriptEl.src) === true);
        if (noPreviousScript || isExternalScript || previousScriptWasLoadedOrWasInline) {
          this.scriptsToExecute.shift();
          this.replacePreviousScript(scriptEl);
        } else {
          // Returning and _not_ changing `previousScriptEl` or shifting off the queue so that
          // this inline script can block until all previous external scripts are finished
          return;
        }
        this.previousScriptEl = scriptEl;
      } else {
        // For some reason this script was removed from the DOM, then get it off the queue
        this.scriptsToExecute.shift();
      }
    }
  }
  static replaceNodesIn(destEl, domNodes, executeScripts) {
    if (executeScripts) {
      destEl.replaceChildren(...domNodes);

      // Replace all script elements inside top-level elements with children (after they actually are in the document)
      const scriptsToExecute = Array.from(destEl.querySelectorAll('script'));

      // TODO, make perf better of embeds with external -> internal -> external scripts by outputting preload links
      // of all the external script tags before doing the replace queue stuff

      const scriptQueue = new ScriptExecutionQueue(scriptsToExecute);
      scriptQueue.start();
      if (scriptQueue.error) {
        throw scriptQueue.error;
      }
    } else {
      // TODO: remove recursively?
      destEl.replaceChildren(...Array.from(domNodes).filter(el => el.nodeName !== 'SCRIPT'));
    }
  }
}